<script lang="ts" module>
	interface ListItem {
		icon?: string;
		label: string;
		value: string;
	}
</script>

<script lang="ts">
	import { Li, List } from "flowbite-svelte";
	import { getContext } from "svelte";
	import TokenizedText from "#lib/components/TokenizedText.svelte";
	import type { ComponentProps } from "#lib/components/page/ComponentProps.js";
	import type { JsonObject } from "#lib/protobuf-compat.js";
	import { listValue, stringValue, structValue } from "#lib/struct.js";
	import type { TokenProvider } from "#lib/tokenProvider.js";
	import type { Writable } from "svelte/store";

	let { id, style, page, mode }: ComponentProps = $props();
	const tokenProvider: Writable<TokenProvider> = getContext("tokenProvider");

	const config = $derived(structValue($page.config, id));

	const items: ListItem[] = $derived(
		listValue(config, "items")?.map(item => {
			const struct = item as JsonObject;
			return { icon: stringValue(struct, "icon"), label: stringValue(struct, "label")!, value: stringValue(struct, "value")! };
		}) ?? [],
	);
</script>

<List tag="ul" list="none" class="max-w-md divide-y divide-gray-200" {style}>
	{#each items as item (item.label + "-" + item.value)}
		<Li class="py-2">
			<div class="flex items-center space-x-4">
				{#if item.icon}
					<div class="shrink-0">
						<img class="h-8 w-8 rounded-full" src={item.icon} alt="" />
					</div>
				{/if}
				<div class="min-w-0 flex-1">
					<p class="truncate text-sm font-medium text-gray-900">{item.label}</p>
				</div>
				<div class="inline-flex items-center text-base font-semibold text-gray-900">
					<TokenizedText provider={$tokenProvider} text={item.value} {mode} />
				</div>
			</div>
		</Li>
	{/each}
</List>
